import { IntlProvider } from 'react-intl';
import { decode } from 'html-entities';
import type { ReactNode } from 'react';
import { createKey } from '@99designs/i18n-utils';

interface I18nProviderProps {
    children: ReactNode;
    locale: string;
    translations: { [key: string]: string };
}

export const I18nProvider = ({ children, locale, translations }: I18nProviderProps) => {
    shim(translations);
    return (
        <IntlProvider locale={locale} messages={translations}>
            {children}
        </IntlProvider>
    );
};

type I18nType = {
    __?: (translation: string) => string;
    __placeholder?: (translation: string) => string;
};

function shim(translations: { [key: string]: string }) {
    (function (self: I18nType) {
        if (typeof self.__ === 'undefined' || typeof window === 'undefined') {
            self.__ = (translation: string): string => {
                return decode(translations[createKey(translation)]) || translation;
            };
        }

        if (typeof self.__placeholder === 'undefined' || typeof window === 'undefined') {
            self.__placeholder = (translation: string): string => {
                return translation;
            };
        }
    })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this);
}
